import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import TeamMain from './TeamMain';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';

const Team = () => {
  return (
    <>
      <HeaderFive />

      <TeamMain />

      <FooterThree />
    </>
  );
};

export default Team;
